import { render } from "./FeedForm.vue?vue&type=template&id=80796100"
import script from "./FeedForm.vue?vue&type=script&lang=js"
export * from "./FeedForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__